import React, { useState, useEffect } from 'react';
import LazyLoad from 'react-lazyload';
import { getApprovedCommentsByBlogId, createComment } from '../../services/commentService';
// Analytics disabled
import './blogStyles.css';

const CommentSection = ({ blogId }) => {
  const [comments, setComments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [formData, setFormData] = useState({ name: '', comment: '', email: '' });
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    const fetchComments = async () => {
      try {
        const approvedComments = await getApprovedCommentsByBlogId(blogId);
        setComments(approvedComments);
      } catch (err) {
        setError('Failed to load comments');
      } finally {
        setLoading(false);
      }
    };
    fetchComments();
  }, [blogId]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name || !formData.comment) return;
    setSubmitting(true);
    try {
      await createComment({
        blogId,
        name: formData.name,
        comment: formData.comment,
        email: formData.email || null,
        status: 'pending' // Assuming comments need approval
      });
      setFormData({ name: '', comment: '', email: '' });
      alert('Comment submitted for approval');
    } catch (err) {
      console.error('Error submitting comment:', err);
      setError('Failed to submit comment');
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) return <div>Loading comments...</div>;
  if (error) return <div>{error}</div>;

  return (
    <div className="comment-section">
      <h3 className="comment-section-title">Comments</h3>
      {comments.length === 0 ? (
        <p className="no-comments">No comments yet. Be the first to share your thoughts!</p>
      ) : (
        <div className="comments-list">
          <LazyLoad>
            {comments.map(comment => (
              <div key={comment.id} className="comment-item">
                <div className="comment-header">
                  <span className="comment-author">{comment.name}</span>
                  <span className="comment-date">
                    {new Date(comment.createdAt.toDate()).toLocaleDateString('en-US', {
                      year: 'numeric',
                      month: 'short',
                      day: 'numeric'
                    })}
                  </span>
                </div>
                <div className="comment-content">
                  {comment.comment}
                </div>
              </div>
            ))}
          </LazyLoad>
        </div>
      )}

      <form className="comment-form" onSubmit={handleSubmit}>
        <div className="comment-form-group">
          <label className="comment-form-label" htmlFor="name">Name *</label>
          <input
            id="name"
            type="text"
            name="name"
            className="comment-input"
            placeholder="Your name"
            value={formData.name}
            onChange={handleInputChange}
            required
          />
        </div>
        <div className="comment-form-group">
          <label className="comment-form-label" htmlFor="email">Email</label>
          <input
            id="email"
            type="email"
            name="email"
            className="comment-input"
            placeholder="Your email (optional)"
            value={formData.email}
            onChange={handleInputChange}
          />
        </div>
        <div className="comment-form-group">
          <label className="comment-form-label" htmlFor="comment">Comment *</label>
          <textarea
            id="comment"
            name="comment"
            className="comment-textarea"
            placeholder="Share your thoughts..."
            value={formData.comment}
            onChange={handleInputChange}
            required
          />
        </div>
        <button type="submit" className="submit-comment-btn" disabled={submitting}>
          {submitting ? (
            <>
              <div className="spinner-border spinner-border-sm me-2" role="status">
                <span className="visually-hidden">Submitting...</span>
              </div>
              Submitting...
            </>
          ) : (
            'Post Comment'
          )}
        </button>
      </form>
    </div>
  );
};

export default CommentSection;